"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.configFrontendSK = void 0;
exports.configFrontendSK = {
    api: process.env.API,
    adSenseClientId: 'ca-pub-2352455228582816',
    cookieConsentDuration: 365,
    dateDisplayFormat: 'DD. MM. YYYY', // this will be handled with i18n later
    analyticsDateFormat: 'D.M.YYYY',
    environment: process.env.NODE_ENV,
    sizeBreakpointXs: 568,
    sizeBreakpointSm: 768,
    sizeBreakpointMd: 1024,
    sizeBreakpointLg: 1280,
    transitionUiSlow: 667, // also used for minimum loading time in ms, to prevent screen blinking
    socialBaseUrl: {
        facebook: 'https://www.facebook.com/',
        linkedinCompany: 'https://www.linkedin.com/company/',
        linkedin: 'https://www.linkedin.com/in/',
        instagram: 'https://www.instagram.com/',
        twitter: 'https://www.twitter.com/',
        youtube: 'https://www.youtube.com/channel/',
    },
    accountType: {
        company: 1,
        student: 2,
    },
    offerTypes: [
        { name: 'Stáž', id: 1 },
        { name: 'Práca', id: 2 },
        { name: 'Dobrovoľníctvo', id: 3 },
        { name: 'Brigáda', id: 4 },
        { name: 'Work & travel', id: 5 },
        { name: 'Živnosť', id: 6 },
    ],
    locations: [
        { name: 'Slovensko', id: 1 },
        { name: 'Banskobystrický kraj', id: 2 },
        { name: 'Bratislavský kraj', id: 3 },
        { name: 'Košický kraj', id: 4 },
        { name: 'Nitriansky kraj', id: 5 },
        { name: 'Prešovský kraj', id: 6 },
        { name: 'Trenčiansky kraj', id: 7 },
        { name: 'Trnavský kraj', id: 8 },
        { name: 'Žilinský kraj', id: 9 },
        { name: 'Bratislava', id: 10 },
        { name: 'Košice', id: 11 },
        { name: 'okres Lučenec', id: 12 },
        { name: 'okres Rimavská Sobota', id: 13 },
        { name: 'okres Galanta', id: 14 },
        { name: 'okres Bardejov', id: 15 },
        { name: 'okres Kežmarok', id: 16 },
        { name: 'okres Turčianske Teplice', id: 17 },
        { name: 'okres Prešov', id: 18 },
        { name: 'okres Trenčín', id: 19 },
        { name: 'okres Humenné', id: 20 },
        { name: 'okres Nitra', id: 21 },
        { name: 'okres Nové Zámky', id: 22 },
        { name: 'okres Topoľčany', id: 23 },
        { name: 'okres Rožňava', id: 24 },
        { name: 'okres Spišská Nová Ves', id: 25 },
        { name: 'okres Vranov nad Topľou', id: 26 },
        { name: 'okres Námestovo', id: 27 },
        { name: 'okres Zvolen', id: 28 },
        { name: 'okres Dunajská Streda', id: 29 },
        { name: 'okres Trebišov', id: 30 },
        { name: 'okres Košice - okolie', id: 31 },
        { name: 'okres Brezno', id: 32 },
        { name: 'okres Banská Štiavnica', id: 33 },
        { name: 'okres Banská Bystrica', id: 34 },
        { name: 'okres Pezinok', id: 35 },
        { name: 'okres Michalovce', id: 36 },
        { name: 'okres Komárno', id: 37 },
        { name: 'okres Sabinov', id: 38 },
        { name: 'okres Levice', id: 39 },
        { name: 'okres Levoča', id: 40 },
        { name: 'okres Veľký Krtíš', id: 41 },
        { name: 'okres Stropkov', id: 42 },
        { name: 'okres Piešťany', id: 43 },
        { name: 'okres Bánovce nad Bebravou', id: 44 },
        { name: 'okres Žiar nad Hronom', id: 45 },
        { name: 'okres Sobrance', id: 46 },
        { name: 'okres Poprad', id: 47 },
        { name: 'okres Nové Mesto nad Váhom', id: 48 },
        { name: 'okres Žilina', id: 49 },
        { name: 'okres Martin', id: 50 },
        { name: 'okres Snina', id: 51 },
        { name: 'okres Zlaté Moravce', id: 52 },
        { name: 'okres Svidník', id: 53 },
        { name: 'okres Púchov', id: 54 },
        { name: 'okres Liptovský Mikuláš', id: 55 },
        { name: 'okres Senec', id: 56 },
        { name: 'okres Ružomberok', id: 57 },
        { name: 'okres Trnava', id: 58 },
        { name: 'okres Senica', id: 59 },
        { name: 'okres Považská Bystrica', id: 60 },
        { name: 'okres Ilava', id: 61 },
        { name: 'okres Prievidza', id: 62 },
        { name: 'okres Hlohovec', id: 63 },
        { name: 'okres Malacky', id: 64 },
        { name: 'okres Partizánske', id: 65 },
        { name: 'okres Bratislava V', id: 66 },
        { name: 'okres Bratislava IV', id: 67 },
        { name: 'okres Bratislava III', id: 68 },
        { name: 'okres Bratislava II', id: 69 },
        { name: 'okres Bratislava I', id: 70 },
        { name: 'okres Žarnovica', id: 71 },
        { name: 'okres Medzilaborce', id: 72 },
        { name: 'okres Myjava', id: 73 },
        { name: 'okres Poltár', id: 74 },
        { name: 'okres Tvrdošín', id: 75 },
        { name: 'okres Skalica', id: 76 },
        { name: 'okres Bytča', id: 77 },
        { name: 'okres Dolný Kubín', id: 78 },
        { name: 'okres Krupina', id: 79 },
        { name: 'okres Čadca', id: 80 },
        { name: 'okres Stará Ľubovňa', id: 81 },
        { name: 'okres Revúca', id: 82 },
        { name: 'okres Detva', id: 83 },
        { name: 'okres Šaľa', id: 84 },
        { name: 'okres Kysucké Nové Mesto', id: 85 },
        { name: 'okres Gelnica', id: 86 },
        { name: 'okres Košice IV', id: 87 },
        { name: 'okres Košice III', id: 88 },
        { name: 'okres Košice I', id: 89 },
        { name: 'okres Košice II', id: 90 },
    ],
    contractTypes: [
        { value: 1, label: 'Plný úväzok' },
        { value: 2, label: 'Skrátený úväzok' },
    ],
    salaryRates: [
        { value: 'hourly', label: 'Na hodinu' },
        { value: 'monthly', label: 'Na mesiac' },
        { value: 'once', label: 'Jednorázovo' },
    ],
    salaryCurrencies: [{ value: '€', label: '€' }],
    durationTypes: [
        { value: 'day', label: 'Deň' },
        { value: 'week', label: 'Týždeň' },
        { value: 'month', label: 'Mesiac' },
        { value: 'year', label: 'Rok' },
    ],
    languages: [
        { code: 'sk', value: 'Slovenský' },
        { code: 'en', value: 'Anglický' },
        { code: 'fr', value: 'Francúzsky' },
        { code: 'cs', value: 'Český' },
        { code: 'de', value: 'Nemecký' },
        { code: 'pl', value: 'Poľský' },
        { code: 'es', value: 'Španielský' },
        { code: 'pt', value: 'Portugalský' },
        { code: 'zh', value: 'Čínsky' },
        { code: 'uk', value: 'Ukrajinský' },
        { code: 'ru', value: 'Ruský' },
        { code: 'hu', value: 'Maďarský' },
    ],
    monthNames: [
        'Január',
        'Február',
        'Marec',
        'Apríl',
        'Máj',
        'Jún',
        'Júl',
        'August',
        'September',
        'Október',
        'November',
        'December',
    ],
    universities: [
        'Akadémia ozbrojených síl generála Milana Rastislava Štefánika',
        'Akadémia Policajného zboru',
        'Akadémia umení v Banskej Bystrici',
        'Bratislavská medzinárodná škola liberálnych štúdií',
        'Ekonomická univerzita v Bratislave',
        'Hudobná a umelecká akadémia Jána Albrechta - Banská Štiavnica, s. r. o., odborná vysoká škola',
        'Katolícka univerzita v Ružomberku',
        'Paneurópska vysoká škola',
        'Prešovská univerzita v Prešove',
        'Slovenská poľnohospodárska univerzita v Nitre',
        'Slovenská technická univerzita v Bratislave',
        'Slovenská zdravotnícka univerzita v Bratislave',
        'Stredoeurópska vysoká škola v Skalici',
        'Technická univerzita v Košiciach',
        'Technická univerzita vo Zvolene',
        'Trenčianska univerzita Alexandra Dubčeka v Trenčíne',
        'Trnavská univerzita v Trnave',
        'Univerzita J. Selyeho',
        'Univerzita Komenského v Bratislave',
        'Univerzita Konštantína Filozofa v Nitre',
        'Univerzita Mateja Bela v Banskej Bystrici',
        'Univerzita Pavla Jozefa Šafárika v Košiciach',
        'Univerzita sv. Cyrila a Metoda v Trnave',
        'Univerzita veterinárskeho lekárstva a&nbsp;farmácie v Košiciach',
        'Vysoká škola bezpečnostného manažérstva v Košiciach',
        'Vysoká škola Danubius',
        'Vysoká škola DTI',
        'Vysoká škola ekonómie a manažmentu verejnej správy v Bratislave',
        'Vysoká škola manažmentu',
        'Vysoká škola medzinárodného podnikania ISM Slovakia v Prešove',
        'Vysoká škola medzinárodných a veřejných vztahů Praha, o. p. s.',
        'Vysoká škola múzických umení v Bratislave',
        'Vysoká škola výtvarných umení v Bratislave',
        'Vysoká škola zdravotníctva a sociálnej práce sv. Alžbety v Bratislave, n. o.',
        'Žilinská univerzita v Žiline',
    ],
    universitySections: [
        'architektúra a urbanizmus',
        'bezpečnostné vedy',
        'biológia',
        'biotechnológie',
        'doprava',
        'drevárstvo',
        'ekologické a environmentálne vedy',
        'ekonómia a manažment',
        'elektrotechnika',
        'farmácia',
        'filológia',
        'filozofia',
        'fyzika',
        'geodézia a kartografia',
        'historické vedy',
        'chémia',
        'chemické inžinierstvo a technológie',
        'informatika',
        'kybernetika',
        'lesníctvo',
        'logopédia a liečebná pedagogika',
        'matematika',
        'mediálne a komunikačné štúdiá',
        'obrana a vojenstvo',
        'ošetrovateľstvo',
        'politické vedy',
        'poľnohospodárstvo a krajinárstvo',
        'potravinárstvo',
        'pôrodná asistencia',
        'právo',
        'priestorové plánovanie',
        'psychológia',
        'sociálna práca',
        'sociológia a sociálna antropológia',
        'stavebníctvo',
        'strojárstvo',
        'teológia',
        'učiteľstvo a pedagogické vedy',
        'umenie',
        'vedy o športe',
        'vedy o umení a kultúre',
        'vedy o Zemi',
        'verejné zdravotníctvo',
        'veterinárske lekárstvo',
        'všeobecné lekárstvo',
        'zdravotnícke vedy',
        'získavanie a spracovanie zemských zdrojov',
        'zubné lekárstvo',
    ],
};
